'use client'

import {
    updateChannelChildren,
    getChannelChildren as getChannelChildren,
} from '@/app/(site)/[username]/channel-children'
import { IChannel } from '@giphy/js-types'
import { useSWRConfig } from 'swr'
import { getChannelUrl } from './urls'

// fetch the parent, and mutate the cache
export function useChannelMutate() {
    const { mutate } = useSWRConfig()
    return async (updatedChannel: IChannel) => {
        // some endpoints return a channel without children and ancestors defined
        updatedChannel.children = updatedChannel.children || []
        updatedChannel.ancestors = updatedChannel.ancestors || []

        updateChannelChildren(updatedChannel.id, updatedChannel.children)

        // update the current channel
        await mutate(getChannelUrl(updatedChannel.id), updatedChannel, {
            optimisticData: updatedChannel,
            revalidate: false,
        })

        // update the parent's children in global state
        if (updatedChannel.parent) {
            let children = getChannelChildren(updatedChannel.parent)
            if (children.find((c) => c.id === updatedChannel.id)) {
                // update a channel in a parent's array
                children = children.map((c) => (c.id === updatedChannel.id ? updatedChannel : c))
            } else {
                // add a channel
                children = [...children, updatedChannel]
            }
            updateChannelChildren(updatedChannel.parent, children)
        }
    }
}
